import React from 'react';
import PropTypes from 'prop-types';

const UiExpandCollapseRightPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M8.795 8L4.376 3.58a.5.5 0 0 1 0-.707l.884-.883a.5.5 0 0 1 .707 0l5.657 5.656a.498.498 0 0 1 0 .708L5.967 14.01a.5.5 0 0 1-.707 0l-.884-.883a.5.5 0 0 1 0-.708L8.796 8z"
    />
  );
};

UiExpandCollapseRightPath.propTypes = {
  fill: PropTypes.string,
};

export default UiExpandCollapseRightPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-expand-collapse-right.jsx